import { useParams } from 'react-router-dom'
import { useAuthContext } from '@/context-state/AuthContext.jsx'

// Get the spaces that belong to the account currently in the URL (':accountId').
// The auth context holds a flat list of every space across all of the user's
// accounts - this scopes it down to the chosen account so a multi-account user
// only ever sees the spaces of the account they picked at login.
export const useAccountSpaces = () => {
    const { accountId } = useParams()
    const { spaces } = useAuthContext()

    // space.account is a raw account id string. Fall back to space.account?._id
    // in case it ever comes back populated, so the comparison stays correct.
    const accountSpaces = spaces.filter(space => (space.account?._id || space.account) === accountId)

    return { accountSpaces }
}
